import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { rendersNativeButton } from "../internal/nativeButton.js";
import { MenuRoot } from "../vendor/@base-ui/react/menu/root/MenuRoot.js";
import { MenuTrigger } from "../vendor/@base-ui/react/menu/trigger/MenuTrigger.js";
import { MenuPortal } from "../vendor/@base-ui/react/menu/portal/MenuPortal.js";
import { MenuPositioner } from "../vendor/@base-ui/react/menu/positioner/MenuPositioner.js";
import { MenuPopup } from "../vendor/@base-ui/react/menu/popup/MenuPopup.js";
import { MenuGroup as MenuGroup$1 } from "../vendor/@base-ui/react/menu/group/MenuGroup.js";
import { MenuItem as MenuItem$1 } from "../vendor/@base-ui/react/menu/item/MenuItem.js";
import { MenuGroupLabel } from "../vendor/@base-ui/react/menu/group-label/MenuGroupLabel.js";
import { MenuLinkItem as MenuLinkItem$1 } from "../vendor/@base-ui/react/menu/link-item/MenuLinkItem.js";
import { Separator } from "../vendor/@base-ui/react/separator/Separator.js";
const Menu = React.forwardRef(function Menu2({
  trigger,
  children,
  open,
  defaultOpen,
  onOpenChange,
  side = "bottom",
  align = "start",
  sideOffset = 6,
  modal = true,
  disabled,
  container,
  className
}, ref) {
  return /* @__PURE__ */ jsxs(MenuRoot, { open, defaultOpen, onOpenChange, modal, disabled, children: [
    /* @__PURE__ */ jsx(MenuTrigger, { render: trigger, nativeButton: rendersNativeButton(trigger) }),
    /* @__PURE__ */ jsx(MenuPortal, { container, children: /* @__PURE__ */ jsx(MenuPositioner, { className: "ev-menu-layer", side, align, sideOffset, collisionPadding: 8, children: /* @__PURE__ */ jsx(MenuPopup, { ref, className: cx("ev-menu", "ev-root", className), children }) }) })
  ] });
});
Menu.displayName = "Menu";
const MenuItem = React.forwardRef(function MenuItem2({ icon, tone = "default", className, children, closeOnClick = true, ...rest }, ref) {
  return /* @__PURE__ */ jsxs(
    MenuItem$1,
    {
      ref,
      className: cx("ev-menu__item", className),
      "data-tone": tone === "default" ? void 0 : tone,
      closeOnClick,
      ...rest,
      children: [
        icon != null && icon !== false ? /* @__PURE__ */ jsx("span", { className: "ev-menu__icon", "aria-hidden": "true", children: icon }) : null,
        children
      ]
    }
  );
});
MenuItem.displayName = "MenuItem";
const MenuLinkItem = React.forwardRef(function MenuLinkItem2({ icon, className, children, closeOnClick = true, ...rest }, ref) {
  return /* @__PURE__ */ jsxs(MenuLinkItem$1, { ref, className: cx("ev-menu__item", className), closeOnClick, ...rest, children: [
    icon != null && icon !== false ? /* @__PURE__ */ jsx("span", { className: "ev-menu__icon", "aria-hidden": "true", children: icon }) : null,
    children
  ] });
});
MenuLinkItem.displayName = "MenuLinkItem";
const MenuSeparator = React.forwardRef(function MenuSeparator2({ className, ...rest }, ref) {
  return /* @__PURE__ */ jsx(Separator, { ref, className: cx("ev-menu__sep", className), ...rest });
});
MenuSeparator.displayName = "MenuSeparator";
const MenuGroup = React.forwardRef(function MenuGroup2({ label, children, ...rest }, ref) {
  return /* @__PURE__ */ jsxs(MenuGroup$1, { ref, ...rest, children: [
    label != null && label !== false ? /* @__PURE__ */ jsx(MenuLabel, { children: label }) : null,
    children
  ] });
});
MenuGroup.displayName = "MenuGroup";
const MenuLabel = React.forwardRef(function MenuLabel2({ className, ...rest }, ref) {
  return /* @__PURE__ */ jsx(MenuGroupLabel, { ref, className: cx("ev-menu__label", className), ...rest });
});
MenuLabel.displayName = "MenuLabel";
export {
  Menu,
  MenuGroup,
  MenuItem,
  MenuLabel,
  MenuLinkItem,
  MenuSeparator
};
//# sourceMappingURL=Menu.js.map
